import effects from 'app/effects/effects'
import * as dropin from 'braintree-web-drop-in'
import { withFormsy } from 'formsy-react'
import { CircularProgress, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import { useFetcher } from 'libs/fetcher'
import Loader from 'app/components/Loader'
import { FuseAnimate } from '@fuse'
import React, { useCallback, useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import * as R from 'ramda'
import { useUserProfileLocalizationLanguage } from 'commons/useUserProfile'
import ErrorFetchingLoading from 'app/main/messages/notificationTimeline/ErrorFetchingLoading'

const PADDING_SIZE = 26

const MapLocaleToDropinLocale = {
  en: 'en_US',
  th: 'th_TH',
  DEFAULT: 'en_US',
}

const useStyles = makeStyles((theme) => ({
  container: {
    '& .braintree-placeholder': {
      display: 'none !important',
    },
    '$ .braintree-heading hidden': {
      display: 'none !important',
    },
    '& *': {
      'font-size': '1.4rem !important',
    },
  },
  overlay: {
    top: `-${PADDING_SIZE}px`,
    left: `-${PADDING_SIZE}px`,
    bottom: `-${PADDING_SIZE}px`,
    right: `-${PADDING_SIZE - 2}px`,
    'z-index': 2,
    background: 'rgba(0,0,0,0.5)',
  },
}))

const PlanBillingPaymentMethodFormsy = ({
  onClose,
  setValue,
  getValue,
  className,
  isCustomerIncluded = true,
  disabled,
  getErrorMessage,
  onInitialDropin,
}) => {
  const classes = useStyles()
  const { formatMessage } = useIntl()
  const userLanguage = useUserProfileLocalizationLanguage()
  const fetchClientToken = useCallback(() => {
    return effects.apis.getBillingToken({ isCustomerIncluded })
  }, [isCustomerIncluded])

  const {
    values: { token: clientToken },
    isLoading,
    errors,
  } = useFetcher(fetchClientToken, '')

  useEffect(() => {
    if (clientToken) {
      dropin.create(
        {
          authorization: clientToken,
          container: '#dropin-container-plan-billing',
          paypal: {
            flow: 'vault',
          },
          locale:
            MapLocaleToDropinLocale[R.prop('code', userLanguage)] ||
            MapLocaleToDropinLocale.DEFAULT,
          translations: {
            Card: formatMessage({
              id: 'planAndBilling.paymentMethod.card.creditCard',
            }),
          },
        },
        function (err, instance) {
          onInitialDropin(instance)
        },
      )
    }
  }, [clientToken, formatMessage, onInitialDropin, userLanguage])

  return (
    <div className={clsx('relative', className)}>
      <Typography className="mb-16">
        <FormattedMessage id="planAndBilling.yourPlan.changePlan.paymentMethod.label" />
      </Typography>
      <ErrorFetchingLoading
        isShow={errors}
        title={<FormattedMessage id="error.general" />}
      />
      <Loader
        isLoading={isLoading}
        placeholder={
          <div className={clsx('flex justify-center')}>
            <FuseAnimate
              enter={{ animation: 'fadeIn' }}
              leave={{ animation: 'fadeOut' }}
            >
              <CircularProgress
                className="self-center m-16"
                color="secondary"
              />
            </FuseAnimate>
          </div>
        }
      >
        <div className={clsx(classes.container, 'mt-16')}>
          <div id="dropin-container-plan-billing"></div>
        </div>
      </Loader>
      {disabled && (
        <div
          className={clsx(classes.overlay, 'absolute cursor-not-allowed ')}
        />
      )}
    </div>
  )
}

export default React.memo(withFormsy(PlanBillingPaymentMethodFormsy))
